import type { ExportRequest } from '@/services/dbConsole'

/**
 * How often an open export screen re-reads the requests. On 29 Oct a request
 * was raised and nobody could tell whether the second admin had seen it; a
 * new request now reaches the approver, and a decision reaches the requester,
 * within this interval, with no reload.
 */
export const REQUEST_POLL_MS = 5_000

/** Who decided, in words that match the status. The denier was stored in the
 *  approver column and printed as "Approved by", which read as the opposite. */
export function decisionLine(request: ExportRequest): string {
  const decider = request.approvedByEmail ?? 'unknown'
  switch (request.status) {
    case 'pending':
      return request.designatedApproverName || request.designatedApproverEmail
        ? `awaiting approval by ${request.designatedApproverName || request.designatedApproverEmail}`
        : 'awaiting approval by a second admin'
    case 'approved':
      return `approved by ${decider}; ready to download once`
    case 'completed':
      return `approved by ${decider}; downloaded by ${request.downloadedByEmail ?? 'unknown'}`
    case 'denied':
      return `denied by ${decider}`
    case 'cancelled':
      return request.approvedByEmail ? `withdrawn after approval by ${decider}` : 'withdrawn before a decision'
    default:
      return request.status
  }
}
